import React, { useState, useEffect } from "react";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import "react-toastify/dist/ReactToastify.css";
import axiosInstance from "../../../../../services/api/API";
import { showCustomAlert } from "../../../../../customComponents/CustomSweetAlert";
import { showErrorAlert } from "../../../../../customComponents/CustomSweetAlert/errorsweetalert";
import Loader from "../../../../../customComponents/CustomLoader";
import { showAlert } from "../../../../../customComponents/CustomSweetAlert/ShowAlert";
import { buttonStyle, isFormValid } from "../../../../../../helpers/common";
import validations from "../../../../../../helpers/validations";

const AddProduct = () => {
  const [formData, setFormData] = useState({
    business_partner_id: "",
    product_name: "",
    description: "",
    status: "", // Initialize status with an empty string or a default value
  });
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [userTypedd, setUserTypedd] = useState([]);
  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");

  const userType = localStorage.getItem("UserType");
  const businessPartnerId = localStorage.getItem("businessPartnerId");

  const handleSubmit = async () => {
    console.log("productformdata", formData);

    // Validate form before submission
    const errors = {};
    let isValid = true;

    CustomerInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        } else if (
          field.required &&
          field.validation &&
          field.validation.pattern &&
          !field.validation.pattern.test(formData[field.name])
        ) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
    const confirmation = await showAlert({
      title: "Confirmation",
      text: "Are you sure you want to create a record in product?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    });

    if (!confirmation.isConfirmed) {
      return;
    }

    setLoading(true);

    try {
      const newformData = new FormData();
      newformData.append("product_name", formData.product_name);
      newformData.append("product_desc", formData.description);
      newformData.append("status", formData?.status === true ? 1 : 0);

      if (formData.productimage) {
        newformData.append("product_image", formData.productimage);
      }

      const response = await axiosInstance.post(
        "/product/create",
        newformData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      console.log("API Response:", response.data);

      if (response.status === 200) {
        await showAlert({
          title: "Success",
          text: "Product created successfully.",
          icon: "success",
          confirmButtonText: "OK",
        });
        navigate("/admin/manage-product/product");
      }
    } catch (error) {
      console.error("Error submitting form:", error);

      const errorMessage =
        error.response?.data?.message ||
        "An error occurred while processing your request.";
      await showAlert({
        title: "Something went wrong",
        text: errorMessage,
        confirmButtonText: "OK",
      });
      setLoading(false);
    } finally {
      setLoading(false); // Hide loading state
    }
  };

  const CustomerInputs = [
    {
      name: "product_name",
      label: "Name",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      placeholder: "Enter Product Name",
      validation: validations?.productName({ required: true }),
    },
    {
      name: "description",
      label: "Description",
      placeholder: "Enter Product Description",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: validations?.description({ required: true }),
    },
    {
      name: "status",
      label: "Status",
      type: "toggle",
      gridClass: "col-lg-4",
    },
    {
      name: "productimage",
      label: "Upload Product Brochure",
      type: "file",
      allowedExtensions: ["jpg", "jpeg", "png", "pdf"],
      // required: true,
      gridClass: "col-lg-6",
      // validation: { required: true },
    },
  ];

  return (
    <>
      <div>
        {loading ? (
          <Loader />
        ) : (
          <>
            <div className="backbutton mt-2 mb-2">
              <img
                style={{ cursor: "pointer" }}
                onClick={() => navigate(-1)}
                src={backicon}
                alt="back"
              />
              <span className="backbtntitle">Add Product</span>
            </div>
            <div className="form-container">
              <span className="cust-det-title mt-2 mb-2">
                Please Enter Product Details
              </span>
              <DynamicForm
                formConfig={CustomerInputs}
                formData={formData}
                setFormData={setFormData}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              />
            </div>
            <div className="btncontainer mt-3">
              <button
                className="submit-btn"
                disabled={
                  !isFormValid(CustomerInputs, formData, validationErrors) ||
                  loading
                }
                style={buttonStyle(
                  CustomerInputs,
                  formData,
                  validationErrors,
                  loading,
                )}
                onClick={handleSubmit}
              >
                {loading ? "Processing..." : "Submit"}
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default AddProduct;
